import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { Animation, Colors, Icon, TooltipWrapper } from '@zapier/design-system';
const Styles = labelStyles('MenuCollapseButton', {
    root: css `
    width: 44px;
    height: 44px;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${Colors.neutral600};
    transition: ${Animation.transitionValue};

    &:hover,
    &:focus {
      background-color: none;
      color: ${Colors.neutral800};
    }
  `,
});
const MenuCollapseButton = (props) => {
    return (isolateComponent(TooltipWrapper, { content: props.label, position: "east", shouldCorrectPosition: false, showTooltipOnTouchDevices: false }, () => (isolateComponent("button", { type: "button", "aria-expanded": props.ariaExpanded, "aria-label": props.ariaLabel || props.label, css: Styles.root, onClick: (event) => {
            if (props.onClick) {
                props.onClick(event);
            }
        } },
        isolateComponent(Icon, { name: props.icon, size: 24 })))));
};
MenuCollapseButton.defaultProps = {
    ariaExpanded: false,
    icon: 'navMenu',
    label: 'Menu',
};
export default MenuCollapseButton;
//# sourceMappingURL=MenuCollapseButton.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)
